var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    设备服务费明细\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }